<template>
  <div id="TicketCP">
    <card collapse :Name="'FilterTicket'">
      <template v-slot:header>
        <h4 class="d-inline">
          فیلتر جستجو
          <!-- <i class="far fa-filter"></i> -->
          <i class="fas fa-filter hover-danger" style="cursor: pointer" data-bs-toggle="popover" data-bs-trigger="hover focus" title="حذف فیلتر جستجو" @click="clearFilter()"></i>
        </h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-6 col-12">
            <small id="grp42">وضعیت</small>
            <div dir="rtl">
              <treeselect
                name="demo"
                :multiple="multiple"
                :clearable="clearable"
                :searchable="searchable"
                :disabled="disabled"
                :open-on-click="openOnClick"
                :open-on-focus="openOnFocus"
                :clear-on-select="clearOnSelect"
                :close-on-select="closeOnSelect"
                :always-open="alwaysOpen"
                :append-to-body="appendToBody"
                :options="options"
                v-model="$store.state.TickCPFilter.value"
                :normalizer="normalizer"
                @select="ItemSelected"
                @deselect="ItemDeselect"
                value-consists-of="LEAF_PRIORITY"
              >
                <label slot="option-label" slot-scope="{ labelClassName, node }" :class="labelClassName">{{ node.label }}</label>
              </treeselect>
            </div>
          </div>
          <div class="col-lg-3 col-12">
            <small id="departeman">دپارتمان</small>
            <div dir="rtl">
              <treeselect
                name="demo2"
                :multiple="multiple"
                :clearable="clearable"
                :searchable="searchable"
                :disabled="disabled"
                :open-on-click="openOnClick"
                :open-on-focus="openOnFocus"
                :clear-on-select="clearOnSelect"
                :close-on-select="closeOnSelect"
                :always-open="alwaysOpen"
                :append-to-body="appendToBody"
                :options="options2"
                v-model="$store.state.TickCPFilter.value2"
                :normalizer="normalizer2"
                @select="ItemSelected2"
                @deselect="ItemDeselect2"
                value-consists-of="LEAF_PRIORITY"
              >
              </treeselect>
            </div>
          </div>
          <div class="col-lg-3 col-12">
            <small id="users">مسئول</small>
            <div dir="rtl">
              <treeselect
                v-if="render"
                name="demo3"
                :multiple="multiple"
                :clearable="clearable"
                :searchable="searchable"
                :disabled="disabled"
                :open-on-click="openOnClick"
                :open-on-focus="openOnFocus"
                :clear-on-select="clearOnSelect"
                :close-on-select="closeOnSelect"
                :always-open="alwaysOpen"
                :append-to-body="appendToBody"
                :options="options3"
                v-model="$store.state.TickCPFilter.value3"
                :normalizer="normalizer3"
                @select="ItemSelected3"
                @deselect="ItemDeselect3"
                value-consists-of="LEAF_PRIORITY"
              >
              </treeselect>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-12 mt-3">
            <small id="LblTblCostomer">مربوط به مشتری</small>

            <SearchableCombo
              :edit="false"
              :grp="0"
              :code="null"
              :ActiveDelete="true"
              @ResultCombo="GetResulTblCostomer"
              @deleteSelected="deleteSelected"
              :rownumintable="3"
              :defaultvalue="$store.state.TickCPFilter.customerId"
              :action="'TblCrmCombo/GetCostomerProduct'"
              :method="'POST'"
              :idinput="'TblCostomer' + request.Id"
              :keyItem="'TblCostomer' + request.id"
              :disabled="false"
              :ClassProps="'required'"
              v-if="showCustomerId"
            >
            </SearchableCombo>
          </div>

          <div class="col-lg-6 col-12 mt-3">
            <small id="LblTblCostomer">نوع تیکت</small>
            <div dir="rtl">
              <treeselect
                name="demo"
                :multiple="multiple"
                :clearable="clearable"
                :searchable="searchable"
                :disabled="disabled"
                :open-on-click="openOnClick"
                :open-on-focus="openOnFocus"
                :clear-on-select="clearOnSelect"
                :close-on-select="closeOnSelect"
                :always-open="alwaysOpen"
                :append-to-body="appendToBody"
                :options="options4"
                v-model="$store.state.TickCPFilter.value4"
                :normalizer="normalizer"
                @select="ItemSelected4"
                @deselect="ItemDeselect4"
                value-consists-of="LEAF_PRIORITY"
              >
                <label slot="option-label" slot-scope="{ labelClassName, node }" :class="labelClassName">{{ node.label }}</label>
              </treeselect>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-9 col-12"></div>
          <div class="col-lg-3 col-12">
            <button class="btn btn-success mt-4 float-left" dir="ltr" @click.prevent="Search()"><span class="mr-2"> جستجو </span><span class="fas fa-search"></span></button>
          </div>
        </div>
      </template>
    </card>
    <Card tools toolsColumns back>
      <template slot="btnCustome">
        <button v-if="mergeButtonShow" @click="mergeTicket()" class="btn btn-primary float-left">ترکیب</button>
      </template>

      <template v-slot:content>
        <button v-if="FromCustomer" @click="returnToCustomer" class="btn btn-warning">بازگشت به مشتری</button>
        <BnpGrid :Noresposive="true" :Sortable="true" :Selectable="false" :action="true" :propsRows="propsRows" :propsColumn="propsColumn" :NoRowNum="true" :ticketManager="true" :hasRowNum="true" @SelectedData="checkTicket" :excel="true" v-if="$store.state.renderComponentGrid">
          <template slot="UserNameFam" slot-scope="props">
            <SearchableCombo
              v-if="$store.state.renderComponentCombo"
              :grp="0"
              :code="null"
              @ResultCombo="GetResulUserId"
              :rownumintable="3"
              :defaultvalue="props.props.TblUserId"
              :action="'TblCrmCombo/GetUserDatails'"
              :method="'POST'"
              :idinput="'UserId' + props.props.Id"
              :keyItem="'UserId' + props.props.Id"
            >
            </SearchableCombo>
          </template>
          <template slot="NameGrp45" slot-scope="props">
            <SearchableCombo
              v-if="$store.state.renderComponentCombo"
              :edit="false"
              :grp="45"
              :code="null"
              @ResultCombo="GetResultGrp45"
              :rownumintable="3"
              :defaultvalue="props.props.TblComboGrpId45"
              :action="'TblCrmCombo/GetComboById'"
              :method="'POST'"
              :idinput="'Grp45Id' + props.props.Id"
              :keyItem="'Grp45Id' + props.props.Id"
            >
            </SearchableCombo>
          </template>
          <template slot="NameGrp41" slot-scope="props">
            <SearchableCombo
              v-if="$store.state.renderComponentCombo"
              :edit="false"
              :noIcone="true"
              :grp="41"
              :code="null"
              @ResultCombo="GetResultGrp41"
              :rownumintable="3"
              :defaultvalue="props.props.TblComboGrpId41"
              :action="'TblCrmCombo/GetComboById'"
              :ClassProps="'d-none'"
              :method="'POST'"
              :idinput="'Grp41Id' + props.props.Id"
              :keyItem="'Grp41Id' + props.props.Id"
            >
            </SearchableCombo>
            <!-- <a :data-title="props.props.NameGrp41" class="input-drop-down" @click="ClickCombo('Grp41Id' + props.props.Id)">
              <i class="fa fa-circle input-drop-down" :style="{ color: Vaziat(props.props.TblComboGrpId41) }"></i>
            </a> -->
            <a :data-title="props.props.NameGrp41" :name="'Grp41Id' + props.props.Id" class="input-drop-down" @click="ClickCombo('Grp41Id' + props.props.Id)">
              <i class="input-drop-down" :name="'Grp41Id' + props.props.Id" :style="{ color: Vaziat(props.props.TblComboGrpId41) }"> {{ props.props.NameGrp41 }}</i>
            </a>
          </template>
          <template slot="score" slot-scope="props">
            <!-- <star-rating :show-rating="false" :star-size="15" :inline="true" v-model="props.props.score" :read-only="true"> </star-rating> -->
            <a href="javascript:;" class="mr-2" @click="GetuserTicket(props.props.id)">
              <i class="fas fa-star text-warning"></i>
            </a>
          </template>
          <template slot="CustomerName" slot-scope="props">
            <a
              v-if="props.props.InsertCustCode > 0"
              href="javascript:;"
              @click="$FindeCustomerById('DetailCustomer', props.props.CId, false, $event)"
              @click.middle="$FindeCustomerById('DetailCustomer', props.props.CId, false, $event)"
              style="white-space: nowrap; cursor: pointer !important"
              data-toggle="tooltip"
              data-placement="top"
              :data-title="props.props.CustomerName"
            >
              {{ props.props.CustomerName.slice(0, 30) + (props.props.CustomerName.length > 30 ? '...' : '') }}
            </a>
            <SearchableCombo
              v-if="$store.state.renderComponentCombo && props.props.InsertCustCode <= 0"
              :edit="false"
              :grp="null"
              :code="null"
              @ResultCombo="ChangeCustomer"
              :rownumintable="3"
              :defaultvalue="props.props.TblCustomerId"
              :action="'TblCrmCombo/GetCostomerProduct'"
              :method="'POST'"
              :idinput="'ChangeCustomer' + props.props.Id"
              :keyItem="'ChangeCustomer' + props.props.Id"
            >
            </SearchableCombo>
          </template>
          <template slot="Title" slot-scope="props">
            <a
              @click="goToChatRoom(props.props.TblChatRoomId, props.props.TblUserId, props.props.Id, props.props.TblComboGrpId41, props.props.TblDepartmentId, props.props.CustomerName, props.props.CustomerCode, props.props.TblCustomerId, props.props)"
              class="ChatroomVisted"
              :href="baseUrl + '/app/ChatRoom#' + props.props.id"
              style="white-space: nowrap;  !important"
              data-toggle="tooltip"
              data-placement="top"
              :data-title="props.props.Title"
              >{{ props.props.Title.slice(0, 30) + (props.props.Title.length > 30 ? '...' : '') }}</a
            >
          </template>
          <template slot="Id" slot-scope="props">
            <a
              class="ChatroomVisted"
              :href="baseUrl + '/app/ChatRoom#' + props.props.id"
              @click="goToChatRoom(props.props.TblChatRoomId, props.props.TblUserId, props.props.Id, props.props.TblComboGrpId41, props.props.TblDepartmentId, props.props.CustomerName, props.props.CustomerCode, props.props.TblCustomerId, props.props)"
              >{{ props.props.Id }}</a
            >
          </template>
          <template slot="action-slot" slot-scope="props">
            <div class="row">
              <div class="text-center col-3">
                <a
                  class="mr-1 ChatroomVisted"
                  :href="baseUrl + '/app/ChatRoom#' + props.props.id"
                  @click="goToChatRoom(props.props.TblChatRoomId, props.props.TblUserId, props.props.Id, props.props.TblComboGrpId41, props.props.TblDepartmentId, props.props.CustomerName, props.props.CustomerCode, props.props.TblCustomerId, props.props)"
                >
                  <h6><span class="fa fa-comments-o hover-info"></span></h6>
                </a>
              </div>
              <div class="text-center col-3">
                <a href="javascript:;" class="mr-1" @click="GetCountTicketResponse(props.props.Id)">
                  <h6><span class="fas fa-calculator" data-title="تعداد پاسخ"></span></h6>
                </a>
              </div>
              <div class="text-center col-3">
                <a href="javascript:;" class="mr-1" @click="OnDetail(props.props)">
                  <h6><span class="fas fa-info text-info hover-danger"></span></h6>
                </a>
              </div>
            </div>
          </template>
        </BnpGrid>
      </template>
    </Card>
    <b-modal size="xl" centered id="modal-LogTicket">
      <template #modal-header="{ close }">
        <b-button size="sm" variant="outline-danger" @click="close()">
          <span aria-hidden="true">&times;</span>
        </b-button>
        <h5>جزئیات اطلاعات</h5>
      </template>

      <template #default>
        <div dir="rtl">
          <bnp-grid v-if="$store.state.renderComponentGridModal" :propsColumn="ColumnRiz" :propsRows="rows" :hasRowNum="true" :Selectable="false"></bnp-grid>
        </div>
      </template>
      <template #modal-footer="{ cancel }">
        <b-button id="CancelCopy" size="sm" variant="danger" @click="cancel()"> بستن </b-button>
      </template>
    </b-modal>
    <b-modal size="lg" centered id="modal-UserTicket">
      <template #modal-header="{ close }">
        <b-button size="sm" variant="outline-danger" @click="close()">
          <span aria-hidden="true">&times;</span>
        </b-button>
        <h5>جزئیات</h5>
      </template>

      <template #default>
        <div dir="rtl">
          <bnp-grid v-if="$store.state.renderComponentGridModal" :propsColumn="ColumnUserTicket" :propsRows="rowsUserTicket" :hasRowNum="true" :Selectable="false">
            <template slot="score" slot-scope="props">
              <star-rating :show-rating="false" :star-size="15" :inline="true" v-model="props.props.score" @rating-selected="scoreChangeNew(props.props)" :read-only="true"> </star-rating>
            </template>
          </bnp-grid>
        </div>
      </template>
      <template #modal-footer="{ cancel }">
        <b-button id="CancelCopy" size="sm" variant="danger" @click="cancel()"> بستن </b-button>
      </template>
    </b-modal>

    <Modal v-if="showModalRefrence" :InheritanceTheme="true" :size="'md-header'" :noHeader="true">
      <template v-slot:headerMd>
        <div class="justify-content-start col-12">
          <h4 class="d-inline">تغییر دپارتمان تیکت</h4>
        </div>
        <span class="fas fa-times Pointer" @click="closeModalRefrence()"></span>
      </template>
      <template v-slot:body>
        <div class="row p-3 text-center justify-content-center">
          {{ checkRefrenceTicketResult.messsage }}

          <div class="col-12 mt-5 text-right">
            <small>انتخاب دپارتمان</small>
            <select class="form-control col-12 mt-2 Pointer" id="changeDepSelectList">
              <option v-for="depart in checkRefrenceTicketResult.userDepartments" :key="depart.departmentId" :value="depart.departmentId">{{ depart.departmentName }}</option>
            </select>
            <div class="d-flex justify-content-center mt-3">
              <button class="btn btn-success col-6 mt-3" @click="ChangeDepartment()">اعمـــال تغییرات دپارتمان</button>
            </div>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import Card from '@/components/Card/Card.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import { createNamespacedHelpers } from 'vuex'
import Modal from '@/pages/BnpCrm/WorkTips/WorkTipsComment.vue'
const { mapState, mapActions } = createNamespacedHelpers('layout')

export default {
  components: { Card, BnpGrid, SearchableCombo, Treeselect, Modal },
  props: ['PropsCustomer', 'FromCustomer'],
  data() {
    return {
      render: true,
      normalizer(node) {
        return {
          id: node.id,
          label: node.name,
        }
      },
      normalizer2(node) {
        return {
          id: node.id,
          label: node.departmentName,
        }
      },
      normalizer3(node) {
        return {
          id: node.id,
          label: node.name,
        }
      },
      DataAxios_GetData: {
        ArryfildValue: {},
        Method: '',
        Action: '',
        Token: this.$session.get('Token'),
      },
      DataAxios_GetData_comboDepUser: {
        ArryfildValue: {},
        Method: '',
        Action: '',
        Token: this.$session.get('Token'),
      },
      DataAxios_GetData_Users: {
        ArryfildValue: {},
        Method: '',
        Action: '',
        Token: this.$session.get('Token'),
      },
      DataAxiosUpdate: {
        ArryfildValue: {},
        Method: 'put',
        Action: '',
        Token: this.$session.get('Token'),
        From: 'Body',
      },
      removeFilter: {
        ListDepId: [],
        ListUsers: [],
      },
      showCustomerId: true,
      signalRTicketConnection: null,
      signalRChatConnection: null,
      Star: null,
      ScoreDisable: false,
      multiple: true,
      clearable: false,
      searchable: true,
      disabled: false,
      openOnClick: true,
      openOnFocus: false,
      clearOnSelect: true,
      closeOnSelect: false,
      alwaysOpen: false,
      appendToBody: false,
      value: [1791, 1793, 1794, 1795, 1797, 1798],
      options: [],
      value2: [],
      options2: [],
      value3: [],
      options3: [],
      options4: [],
      ColumnRiz: [
        { name: 'LogDate', label: 'تاریخ', visibility: true },
        { name: 'Action', label: 'عملیات', visibility: true },
      ],
      rows: [],
      ColumnUserTicket: [
        { name: 'Id', label: 'Id', visibility: false },
        { name: 'NamFam', label: 'نام کاربر', visibility: true },
        { name: 'score', label: 'امتیاز', visibility: true },
      ],
      rowsUserTicket: [],
      DataAxios: {},
      DataAxoisRiz: {
        ArryfildValue: {
          SoftwareId: 2,
          UserId: 1,
          FormName: 'frmTickets',
          ShowView: 0,
        },
        Method: 'post',
        Action: 'ReadGridColumns',
      },
      propsColumn: [],
      propsRows: [],
      userId: this.$session.get('UserInfo').tblUserId,
      UserDepartmentShow: false,
      departmentIdForTicketRefrence: null,
      DataaxiosDepUser: {
        Action: 'Ticket/GetUserDepartment',
        Method: 'Get',
        ArryfildValue: null,
      },
      usersByDepartment: [],
      selectedUser: [],
      ticketId: null,
      ticketTitle: null,
      note: '',
      ticketItemId: null,
      userId: this.$session.get('UserInfo').tblUserId,
      ticket: [],
      connectionId: null,
      connectionIdChat: null,
      request: {},
      DataaxiosUserTicket: {
        Action: 'Ticket/GetUserChatTicket',
        Method: 'post',
        ArryfildValue: null,
        ticketNumber: null,
      },
      baseUrl: '',
      manualStopHub: false,
      ticketHubConnected: false,
      chattHubConnected: false,
      chatHubInterval: null,
      ticketInterval: null,
      firstSelect: true,
      mergeTickesId: [],
      lastF2Prees: new Date(),
      departmentForCombo: [],
      showModalRefrence: false,
      checkRefrenceTicketResult: {},
      changeDepartmentRequest: {},
      mergeButtonShow: false,
      userDepartmets: this.$session.get('UserDepartments'),
    }
  },

  computed: {
    ...mapState(['LastFilterSearchTicket']),
  },
  methods: {
    ...mapActions(['setLastFilterSearchTicket', 'removeLastFilterSearchTicket']),
    returnToCustomer() {
      this.$router.push({
        name: 'DetailCustomer',
        params: {
          tblCustomerId: this.PropsCustomer,
          activeTab: 1,
        },
      })
    },
    closeModalRefrence() {
      this.showModalRefrence = false
      this.$store.state.renderComponentCombo = false
      this.$nextTick(() => {
        this.$store.state.renderComponentCombo = true
      })
    },
    clearFilter() {
      this.$store.state.TickCPFilter.value2 = []
      this.userDepartmets.forEach((el) => {
        this.$store.state.TickCPFilter.value2.push(el)
      })
      this.GetDepartmentUsers(false, 40).then(() => {
        this.$store.state.TickCPFilter.value3 = []
        this.$store.state.TickCPFilter.value3.push(this.userId)
        this.$store.state.TickCPFilter.value = [1791, 1793, 1794, 1795, 1797, 1798, 1841]
        this.$store.state.TickCPFilter.value4 = []
        this.$store.state.TickCPFilter.customerId = undefined
        this.showCustomerId = false
        this.$nextTick(() => {
          this.showCustomerId = true
        })
        this.Search()
        this.mergeTickesId = []
      })
      // this.Search()
      // this.mergeTickesId = []
    },
    GetuserTicket(id) {
      this.DataaxiosUserTicket.Action = 'Ticket/GetUserChatTicket/' + id
      this.$PostData(this.DataaxiosUserTicket)
        .then((response) => {
          if (response.length > 0) {
            this.rowsUserTicket = response
          }
        })
        .finally(() => {
          this.$bvModal.show('modal-UserTicket')
          this.$store.state.renderComponentGridModal = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGridModal = true
          })
        })
    },
    GetResulTblCostomer(data) {
      if (data.id != null) {
        this.$store.state.TickCPFilter.customerId = data.id
      }
    },
    deleteSelected() {
      this.$store.state.TickCPFilter.customerId = null
    },
    async Search(LastFilterSearchTicket) {
      var DataaxiosDepUser = {
        Action: 'Ticket',
        Method: 'Post',
      }
      let ls = false
      if (LastFilterSearchTicket != undefined) {
        if (LastFilterSearchTicket.ListDepId != undefined) {
          DataaxiosDepUser.ArryfildValue = {
            ListDepId: this.$store.state.TickCPFilter.value2,
            ListGrp41: this.$store.state.TickCPFilter.value,
            tblCustomerId: this.$store.state.TickCPFilter.customerId,
            ListUsers: this.$store.state.TickCPFilter.value3,
            ListGrp45: this.$store.state.TickCPFilter.value4,
          }
          ls = true
          // this.$store.state.TickCPFilter.value2 = LastFilterSearchTicket.ListDepId
          // this.$store.state.TickCPFilter.value = LastFilterSearchTicket.ListGrp41
          // this.request.TblCustomerId = LastFilterSearchTicket.tblCustomerId
          // this.$store.state.TickCPFilter.value3 = LastFilterSearchTicket.ListUsers

          this.showCustomerId = false
          this.$nextTick(() => {
            this.showCustomerId = true
          })
        }
      }
      if (!ls) {
        DataaxiosDepUser.ArryfildValue = {
          ListDepId: this.$store.state.TickCPFilter.value2,
          ListGrp41: this.$store.state.TickCPFilter.value,
          tblCustomerId: this.$store.state.TickCPFilter.customerId,
          ListUsers: this.$store.state.TickCPFilter.value3,
          ListGrp45: this.$store.state.TickCPFilter.value4,
        }
      }

      this.setLastFilterSearchTicket(DataaxiosDepUser.ArryfildValue)

      this.$PostData(DataaxiosDepUser)
        .then((response) => {
          this.propsRows = response
          this.$store.state.renderComponentCombo = false
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentCombo = true
            this.$store.state.renderComponentGrid = true
          })
          this.mergeTickesId = []
        })
        .catch((error) => {
          console.error('CATCH', error)
        })
    },
    ClickCombo(id) {
      document.getElementById(id).click()
    },
    ChangeDepartment() {
      let departmentId = document.getElementById('changeDepSelectList').value

      this.signalRTicketConnection
        .invoke('ChangeDepartment', String(this.changeDepartmentRequest.ticketId), String(departmentId))
        .then((res) => {
          var ticket = this.propsRows.find((element) => element.Id == this.changeDepartmentRequest.ticketId)
          ticket.TblDepartmentId = departmentId
          // this.$mySweetDefaultTost('عملیات موفق', 'دپارتمان تیکت با موفقیت تغییر کرد', 'success', 2000)
          //ارجاع پس از تغییر دپارتمان
          this.signalRTicketConnection
            .invoke('ReferenceTicket', String(this.changeDepartmentRequest.ticketId), String(this.changeDepartmentRequest.userIdTask), String(this.$session.get('UserInfo').tblUserGrpId))
            .then((res) => {
              this.$mySweetDefaultTost('عملیات موفق', 'تیکت با موفقیت ارجاع شد', 'success', 2000)
              var ticket = this.propsRows.find((element) => element.Id == this.changeDepartmentRequest.ticketId)
              if (ticket != undefined) {
                ticket.TblUserId = this.changeDepartmentRequest.userIdTask
              }
              // this.Search()
              // this.mergeTickesId = []
              this.showModalRefrence = false
            })
            .catch((error) => {
              this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی در ارجاع تیکت رخ داد', 'error', 2000)
              console.error('CATCH', error)
            })
        })
        .catch((error) => {
          this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی رخ داد', 'error', 2000)
          console.error('CATCH', error)
        })
    },
    ChangeCustomer(data) {
      if ((data.id != null && !data.IsDefault) || data.deleted) {
        var DataAxios = { Method: 'POST', Action: 'Ticket/ChangeCustomer', ArryfildValue: { TkcetId: Number(data.key.replace('ChangeCustomer', '')), tblCustomerId: data.id, tblusergrp: this.$session.get('UserInfo').tblUserGrpId } }
        this.$PostData(DataAxios).then((result) => {
          if (result.status == 'success') {
            this.$toasted.success(result.text, { duration: 2000 })
          } else {
            this.$toasted.error(result.text, { duration: 2000 })
          }
          this.Search()
        })
      }
    },

    ItemSelected4(node) {
      this.$store.state.TickCPFilter.value4.push(node.id)
    },
    ItemDeselect4(node) {
      let find = this.$store.state.TickCPFilter.value4.find((x) => x.id == node.id)
      let index = this.$store.state.TickCPFilter.value4.indexOf(find)
      this.$store.state.TickCPFilter.value4.splice(index, 1)
    },
    ItemSelected(node) {
      this.$store.state.TickCPFilter.value.push(node.id)
    },
    ItemDeselect(node) {
      for (let index = 0; index < this.$store.state.TickCPFilter.value.length; index++) {
        if (this.$store.state.TickCPFilter.value[index] == node.id) {
          this.$store.state.TickCPFilter.value.splice(index, 1)
        }
      }
    },
    GetDepartmentUsers(Ismounted, line) {
      return new Promise((success, reject) => {
        if (this.$store.state.TickCPFilter.value2.length == 0) {
          this.options3 = []
          this.$store.state.TickCPFilter.value3 = []
        } else {
          var DataAxios = { Method: 'POST', Action: 'TblCrmCombo/GetUserDatailsByDepartment', ArryfildValue: { DepartmentIds: this.$store.state.TickCPFilter.value2.toString() } }
          this.$PostData(DataAxios)
            .then((result) => {
              this.options3 = result

              //#region  اپدیت مسئول تیکت بعد از تغییر دپارتمان
              let indexsSpliceUsers = []
              this.$store.state.TickCPFilter.value3.forEach((el) => {
                let find = this.options3.find((x) => x.id == el)
                if (find == undefined) {
                  indexsSpliceUsers.push(el)
                }
              })

              indexsSpliceUsers.forEach((el) => {
                let vla3Find = this.$store.state.TickCPFilter.value3.find((x) => x == el)
                let index = this.$store.state.TickCPFilter.value3.indexOf(vla3Find)
                this.$store.state.TickCPFilter.value3.splice(index, 1)
              })
              //#endregion

              this.render = false
              this.$nextTick(() => {
                this.render = true
              })
            })
            .finally(() => {
              //ز صفحه مشتری اومده باشه
              if (this.FromCustomer) {
                this.$store.state.TickCPFilter.value = [1791, 1793, 1794, 1795, 1797, 1798, 1841, 1842]
                this.$store.state.TickCPFilter.value3 = []
                this.$store.state.TickCPFilter.value4 = []
                this.FromCustomer = false
              }
              if (Ismounted) {
                this.Search()
                this.mergeTickesId = []
              }
              this.addSelectAll_treeSelect(this.options3, 3)

              if (this.$route.params.formHeader != undefined) {
                this.clearFilter()
                this.$route.params.formHeader = undefined
              }
              success()
            })
        }
      })
    },

    addSelectAll_treeSelect(optionList, num) {
      let newOtptionList
      if (num == 2) {
        newOtptionList = [
          {
            id: 'selectAll',
            departmentName: 'انتخاب همه',
            children: optionList,
          },
        ]
      } else {
        newOtptionList = [
          {
            id: 'selectAll',
            name: 'انتخاب همه',
            children: optionList,
          },
        ]
      }
      if (num == 1) {
        this.options = newOtptionList
      } else if (num == 2) {
        this.options2 = newOtptionList
      } else if (num == 3) {
        this.options3 = newOtptionList
      } else if (num == 4) {
        this.options4 = newOtptionList
      }
    },
    ItemSelected2(node) {
      setTimeout(() => {
        this.GetDepartmentUsers(false, 526)
      }, 190)
    },
    ItemDeselect2(node) {
      // for (let index = 0; index < this.$store.state.TickCPFilter.value2.length; index++) {
      //   if (this.$store.state.TickCPFilter.value2[index] == node.id) {
      //     this.$store.state.TickCPFilter.value2.splice(index, 1)
      //   }
      // }
      setTimeout(() => {
        this.GetDepartmentUsers(false, 534)
      }, 190)
    },
    ItemSelected3(node) {},
    ItemDeselect3(node) {
      for (let index = 0; index < this.$store.state.TickCPFilter.value3.length; index++) {
        if (this.$store.state.TickCPFilter.value3[index] == node.id) {
          this.$store.state.TickCPFilter.value3.splice(index, 1)
        }
      }
    },
    GetResulUserId(data) {
      if ((data.id != null && !data.IsDefault) || data.deleted) {
        var index = Number(data.key.replace('UserId', ''))
        this.DataAxios.TblUserIdTask = data.id
        if (data.id.length < 1) {
          return
        }
        let ticketFind = this.propsRows.find((x) => x.Id == index)

        if (ticketFind.TblComboGrpId45 == null || ticketFind.TblComboGrpId45 == '') {
          this.$mySweetDefaultTost('', 'ابتدا نوع تیکت را مشخص نمایید', 'warning', 3500)
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
          return
        }
        let departmentId = ticketFind.TblDepartmentId
        let Dataaxios = {
          Action: 'Ticket/CheckDepartmentRefrenceTicket',
          Method: 'Post',
          ArryfildValue: {
            userId: this.DataAxios.TblUserIdTask,
            departmentId: departmentId,
          },
        }
        this.$PostData(Dataaxios).then((res) => {
          if (res.isSuccess == true) {
            this.signalRTicketConnection
              .invoke('ReferenceTicket', String(index), String(this.DataAxios.TblUserIdTask), String(this.$session.get('UserInfo').tblUserGrpId))
              .then((res) => {
                this.$mySweetDefaultTost('عملیات موفق', 'تیکت با موفقیت ارجاع شد', 'success', 2000)
                var ticket = this.propsRows.find((element) => element.Id == index)
                if (ticket != undefined) {
                  ticket.TblUserId = data.id
                }
                // this.Search()
                this.mergeTickesId = []
              })
              .catch((error) => {
                this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی رخ داد', 'error', 2000)
                console.error('CATCH', error)
              })
          } else {
            this.showModalRefrence = true
            this.changeDepartmentRequest.ticketId = index
            this.changeDepartmentRequest.userIdTask = this.DataAxios.TblUserIdTask
            this.checkRefrenceTicketResult = res
          }
        })
      }
    },
    GetResultGrp45(data) {
      if ((data.id != null && !data.IsDefault) || data.deleted || data.deleted) {
        this.DataAxios.tblComboGrpId45 = data.id
        var index = Number(data.key.replace('Grp45Id', ''))
        let request = {
          TicketId: index,
          TblComboGrpId45: this.DataAxios.tblComboGrpId45,
        }
        request = JSON.stringify(request)

        this.signalRTicketConnection
          .invoke('Grp45Ticket', request)
          .then((res) => {
            this.$toasted.success('توع تیکت با موفقیت تغییر یافت', {
              action: {
                text: 'بستن',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0)
                },
              },
            })
            let findTicket = this.propsRows.find((x) => x.Id == index)
            findTicket.TblComboGrpId45 = this.DataAxios.tblComboGrpId45
            // this.Search()
            // this.mergeTickesId = []
          })
          .catch((error) => {
            this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی رخ داد', 'error', 2000)
            console.error('CATCH', error)
          })
      }
    },
    GetResultGrp41(data) {
      if ((data.id != null && !data.IsDefault) || data.deleted) {
        this.DataAxios.tblComboGrpId41 = data.id
        var index = Number(data.key.replace('Grp41Id', ''))
        var record = this.propsRows.find((element) => element.Id == index)

        this.signalRChatConnection
          .invoke('ChangeStatus', String(index), data.id + '', String(this.$session.get('UserInfo').tblUserGrpId), record.TblDepartmentId + '', record.TblChatRoomId + '')
          .then((res) => {
            this.$toasted.success('وضعیت تیکت با موفقیت نغییر یافت', {
              action: {
                text: 'بستن',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0)
                },
              },
            })
            this.Search()
            this.mergeTickesId = []
          })
          .catch((error) => {
            this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی رخ داد', 'error', 2000)
            console.error('CATCH', error)
          })
      }
    },
    goToChatRoom(chatRoomId, ticketManagerTblUserId, ticketId, tblComboIdTicketStatus, departmentId, customerName, customerCode, tblCustomerId, ticket) {
      // this.$store.state.FilterdTickets = this.propsRows
      this.$router.push({
        name: 'ChatRoom',
        params: {
          chatRoomId: chatRoomId,
          ticketManagerTblUserId: ticketManagerTblUserId,
          ticketId: ticketId,
          tblComboIdTicketStatus: tblComboIdTicketStatus,
          departmentId: departmentId,
          customerName: customerName,
          customerCode: customerCode,
          tblCustomerId: tblCustomerId,
          tblUserGrpIdInsertTicket: ticket.TblUserGrpIdInsert,
          ticket: ticket,
          tblComboGrpId45: ticket.TblComboGrpId45,
          tblComboGrpId42: ticket.TblComboGrpId42,
          tblCombogrp37AxarinVazeit: ticket.tblCombogrp37AxarinVazeit,
        },
      })
    },
    userDepartment() {
      this.$PostData(this.DataaxiosDepUser)
        .then((res) => {
          this.usersByDepartment = res
        })
        .catch((err) => {
          console.error(err)
        })
    },
    switchSelect(ticketId) {
      var record = this.propsRows.find((element) => element.Id == ticketId)

      this.signalRChatConnection
        .invoke('ReferenceTicket', String(ticketId), String(record.ticketManagerTblUserId))
        .then((res) => {
          this.$mySweetDefaultTost('عملیات موفق', 'تیکت با موفقیت ارجاع شد', 'success', 2000)
        })
        .catch((error) => {
          this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی رخ داد', 'error', 2000)
          console.error('CATCH', error)
        })
    },
    closeRefrence() {
      this.UserDepartmentShow = false
      this.note = null
      this.selectedUser = null
    },
    OnDetail(row) {
      var DataAxios = {
        Action: 'Ticket/GetTicketLog',
        Method: 'Get',
        ArryfildValue: {
          Id: row.Id,
        },
      }
      this.$GetData_Header(DataAxios)
        .then((response) => {
          this.rows = response
        })
        .finally(() => {
          this.$bvModal.show('modal-LogTicket')
          this.$store.state.renderComponentGridModal = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGridModal = true
          })
        })
    },
    Vaziat(id) {
      var colors = ['#5CB0FF', '#eddd85', '#FDA700', '#fd397a', '#21AE89', '#5578eb', '#657685', '#b7d91e']
      var values = ['1798', '1797', '1796', '1795', '1794', '1793', '1792', '1791', '1841']
      var num = values.indexOf(id + '')
      return colors[num]
    },
    tryConnectTicketHub() {
      if (!this.ticketHubConnected) {
        if (!this.manualStopHub) {
          this.ticketHub().then(() => {
            this.ticketHubConnected = true
            clearInterval(this.ticketInterval)
          })
        }
      }
    },
    tryConnectChatHub() {
      if (!this.chattHubConnected) {
        if (!this.manualStopHub) {
          this.chatHub().then(() => {
            this.chattHubConnected = true
            clearInterval(this.chatHubInterval)
          })
        }
      }
    },
    async chatHub() {
      this.$GetSignalRChat()
        .then((res) => {
          this.signalRChatConnection = res
          this.connectionIdChat = res.connection.connectionId

          res.invoke('UserJoinGroup', String(this.userId))
          res.on('changeStatus', (ticketId, status, tblComboGrpId41) => {
            var ticket = this.propsRows.find((x) => x.Id == ticketId)

            let inFilterStatus = this.$store.state.TickCPFilter.value
            let isInFilter = false

            for (let n = 0; n < inFilterStatus.length; n++) {
              if (inFilterStatus[n] == tblComboGrpId41) {
                isInFilter = true
              }
            }

            if (isInFilter) {
              if (ticket == undefined) {
                this.Search()
                this.mergeTickesId = []
              } else {
                ticket.TblComboGrpId41 = tblComboGrpId41
                ticket.NameGrp41 = status
                this.$store.state.renderComponentGrid = false
                this.$nextTick(() => {
                  this.$store.state.renderComponentGrid = true
                })
              }
            } else {
              if (ticket != undefined) {
                let index = this.propsRows.indexOf(ticket)
                this.propsRows.splice(index, 1)
                this.$store.state.renderComponentGrid = false
                this.$nextTick(() => {
                  this.$store.state.renderComponentGrid = true
                })
              }
            }
          })
        })
        .catch((error) => {
          this.$mySweetDefaultTost('عملیات ناموفق', 'خطا در ایجاد اتصال لطفا مجددا تلاش کنید', 'error', 2000)
          console.error('CATCH', error)
        })
    },

    async ticketHub() {
      this.$GetSignalR()
        .then((res) => {
          this.signalRTicketConnection = res
          this.connectionId = res.connection.connectionId

          res.invoke('UserJoinGroup', String(this.userId))

          res.on('getNewTicket', (TicketId) => {
            this.Search()
            this.mergeTickesId = []
          })

          res.on('ReferenceTicketDepartment', (ticketId, tblUserId, depId) => {    
            let findTicket = this.propsRows.find((x) => x.Id == ticketId)
            if (findTicket != undefined) {
              findTicket.TblUserId = tblUserId
              findTicket.TblDepartmentId = depId
            }

            let filterDepartment = this.$store.state.TickCPFilter.value2
            let filteUserManage = this.$store.state.TickCPFilter.value3

            let isFilterDep = filterDepartment.filter((x) => x == depId).length == 1

            let isFilteUserManage = false
            if (filteUserManage.length == 0) {
              isFilteUserManage = true
            } else {
              isFilteUserManage = filteUserManage.filter((x) => x == tblUserId).length == 1
            }
            let depFind = this.options2.find((x) => x.id == depId)
            let depName;
            if(depFind != undefined & depFind != null){
              depName = depFind.departmentName
            }
            if (isFilterDep == false || isFilteUserManage == false) {
              if (findTicket != undefined) {
                let index = this.propsRows.indexOf(findTicket)
                this.propsRows.splice(index, 1)
              }
            } else {
              if (findTicket != undefined) {
                findTicket.DepartmentName = depName
                findTicket.TblUserId = tblUserId
                findTicket.TblDepartmentId = depId
              } else {
                this.Search()
              }
            }

            this.$store.state.renderComponentGrid = false
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true
            })
          })

          res.on('Grp45Ticket', (ticketId, grp45Id) => {
            var ticket = this.propsRows.find((x) => x.Id == ticketId)
            if (ticket != undefined) {
              ticket.TblComboGrpId45 = grp45Id
              this.$store.state.renderComponentGrid = false
              this.$nextTick(() => {
                this.$store.state.renderComponentGrid = true
              })
            }
          })

          res.on('changeStatus', (ticketId, status, tblComboGrpId41) => {
            var ticket = this.propsRows.find((x) => x.Id == ticketId)

            let inFilterStatus = this.$store.state.TickCPFilter.value
            let isInFilter = false

            for (let n = 0; n < inFilterStatus.length; n++) {
              if (inFilterStatus[n] == tblComboGrpId41) {
                isInFilter = true
              }
            }

            if (isInFilter) {
              if (ticket == undefined) {
                this.Search()
                this.mergeTickesId = []
              } else {
                ticket.TblComboGrpId41 = tblComboGrpId41
                ticket.NameGrp41 = status
                this.$store.state.renderComponentGrid = false
                this.$nextTick(() => {
                  this.$store.state.renderComponentGrid = true
                })
              }
            } else {
              if (ticket != undefined) {
                let index = this.propsRows.indexOf(ticket)
                this.propsRows.splice(index, 1)
                this.$store.state.renderComponentGrid = false
                this.$nextTick(() => {
                  this.$store.state.renderComponentGrid = true
                })
              }
            }
          })

          res.on('GetNotif', () => {
            this.Search()
            this.mergeTickesId = []
          })
        })
        .catch((error) => {
          this.$mySweetDefaultTost('عملیات ناموفق', 'خطا در ایجاد اتصال لطفا مجددا تلاش کنید', 'error', 2000)
          console.error('CATCH', error)
        })
      // .finally(() => {
      //   if (this.signalRTicketConnection._connectionStarted === false || this.signalRTicketConnection == null) {
      //     setTimeout(() => {
      //       this.ticketHub()
      //     }, 1000)
      //   }
      // })
    },

    checkTicket(data) {
      this.mergeTickesId = data
      if (data.length == 0) {
        this.firstSelect = true
        this.mergeButtonShow = false
      }
      if ((data.length == 1) & this.firstSelect) {
        // this.$toasted.success('برای ادغام دکمه F2 را فشار دهید', {
        //   action: {
        //     text: '',
        //     onClick: (e, toastObject) => {
        //       toastObject.goAway(0)
        //     },
        //   },
        // })
        this.mergeButtonShow = true
      }
      if (data.length == 2) {
        this.firstSelect = false
      }
    },

    getGrp45Options() {
      return new Promise((success, reject) => {
        let Dataaxios = {
          Action: 'TblCrmCombo/GetComboById',
          Method: 'Post',
          ArryfildValue: {
            Id: 45,
          },
        }
        this.$PostData(Dataaxios)
          .then((res) => {
            this.options4 = res
            this.addSelectAll_treeSelect(this.options4, 4)
            success()
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    mergeTicket() {
      var ids = []
      for (var i = 0; i < this.mergeTickesId.length; i++) {
        ids[i] = this.mergeTickesId[i].Id
      }

      let Dataaxios = {
        Action: 'Ticket/TicketMerge',
        Method: 'Post',
        ArryfildValue: ids,
      }
      this.$PostData(Dataaxios)
        .then((response) => {
          if (response.Status) {
            this.$mySweetDefaultTost('عملیات موفق', response.Message, 'success', 2000)
            this.Search()
            this.mergeTickesId = []
          } else if (!response.Status) {
            this.$mySweetDefaultTost('عملیات ناموفق', response.Message, 'info', 3000)
          }
        })
        .catch((error) => {
          console.error(error)
          this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی رخ داد', 'error', 2000)
        })
    },

    GetCountTicketResponse(id) {
      this.$PostData_new('get', 'Ticket/GetCountTicketResponse/' + id).then((response) => {
        let message = 'تعداد پاسخ در تیکت ' + id + '#:  ' + response + ' عدد '
        this.$toasted.info(message, {
          action: {
            text: '',
            onClick: (e, toastObject) => {
              toastObject.goAway(0)
            },
          },
        })
      })
    },
  },

  created() {
    this.chatHub()
    this.ticketHub()
  },
  mounted() {
    this.baseUrl = window.location.origin
    this.DataAxios_GetData.Action = 'TblCrmCombo/GetComboById'
    this.DataAxios_GetData.Method = 'POST'
    this.DataAxios_GetData.ArryfildValue = { Id: 41 }
    this.$PostData(this.DataAxios_GetData)
      .then((data) => {
        if (data.status != 'Not Ok') {
          this.options = data
        }
      })
      .finally(() => {
        this.addSelectAll_treeSelect(this.options, 1)
        if (this.FromCustomer) {
          this.$store.state.TickCPFilter.customerId = this.PropsCustomer
          this.showCustomerId = false
          this.$nextTick(() => {
            this.showCustomerId = true
          })
        }
        this.DataAxios_GetData_comboDepUser.Action = 'Ticket/GetDepartmentForCombo'
        this.DataAxios_GetData_comboDepUser.Method = 'Get'
        this.$PostData(this.DataAxios_GetData_comboDepUser)
          .then((data) => {
            if (data.status != 'Not Ok') {
              this.options2 = data
              for (let index = 0; index < data.length; index++) {
                // if (this.$store.state.TickCPFilter.value2.length == 0) {
                //   this.$store.state.TickCPFilter.value2.push(data[index].id)
                // }
                this.removeFilter.ListDepId.push(data[index].id)
              }
              if (this.$store.state.TickCPFilter.value2.length == 0) {
                this.userDepartmets.forEach((el) => {
                  this.$store.state.TickCPFilter.value2.push(el)
                })
              }

              //از صفحه مشتری اومده باشه
              if (this.FromCustomer) {
                this.$store.state.TickCPFilter.value2 = []
                this.options2.forEach((el) => {
                  this.$store.state.TickCPFilter.value2.push(el.id)
                })
              }
            }
          })
          .finally(() => {
            this.getGrp45Options().finally(() => {
              this.GetDepartmentUsers(true, 774)
            })
            this.addSelectAll_treeSelect(this.options2, 2)
          })
      })
  },
  beforeMount() {
    this.$GetColumns(this.DataAxoisRiz, true)
      .then((data) => {
        this.propsColumn = data
      })
      .finally(() => {
        this.$store.state.renderComponentGrid = false
        this.$nextTick(() => {
          this.$store.state.renderComponentGrid = true
        })
      })
  },
  beforeDestroy() {
    // this.signalRTicketConnection.invoke('RemoveFromGroup', this.connectionId, String(this.userId))
    // this.signalRChatConnection.invoke('UserRemoveChatRoom', this.connectionIdChat, null, String(this.userId))
    this.manualStopHub = true
    this.signalRTicketConnection.stop().then(() => {
      this.manualStopHub = true
      clearInterval(this.ticketInterval)
    })
    this.signalRChatConnection.stop().then(() => {
      this.manualStopHub = true
      clearInterval(this.chatHubInterval)
    })
  },
}
</script>

<style>
.vue-treeselect__multi-value-item {
  cursor: pointer !important;
  display: inline-table !important;
  background: #61b0ff !important;
  padding: 2px 0 !important;
  border: 1px solid transparent !important;
  border-radius: 2px !important;
  color: #039be5 !important;
  font-size: 12px !important;
  vertical-align: top !important;
}

#TicketCP table input {
  font-size: small !important;
}

#TicketCP table {
  font-size: smaller !important;
}

.ChatroomVisted:visited {
  color: gray !important;
}
</style>
